import { isTodayInTimezone } from '@app/components/date/ldate-utils';
import { LDate } from '@app/components/date/LDate';
import { LTime } from '@app/components/date/LTime';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { ListViewLoadMore } from '@app/core/list-view/ListViewLoadMore';
import { defineMessage, FormattedMessage } from 'react-intl';

const loadMoreTodayMessage = defineMessage({
  id: 'logger.streamScreen.liveTopics.panel.loadMoreToday',
  defaultMessage: 'Mostrar anteriores a las {time}',
});

const loadMoreOtherDayMessage = defineMessage({
  id: 'logger.streamScreen.liveTopics.panel.loadMoreOtherDay',
  defaultMessage: 'Mostrar anteriores a {date} {time}',
});

/**
 * Load-more chip for the Live Topics list.
 * Label uses the oldest *fetched* topic time (unfiltered cursor), so the clock still
 * updates when a category/text filter hides the newly loaded rows.
 * Date is included only when that timestamp is not today in the active timezone.
 */
export function LiveTopicsLoadMore({
  oldestFetchedStartTime,
  isLoadingMore,
  onLoadMore,
}: {
  oldestFetchedStartTime: string;
  isLoadingMore: boolean;
  onLoadMore: () => void;
}) {
  const tz = useTimezone();
  const showDate = !isTodayInTimezone(oldestFetchedStartTime, tz);

  const time = <LTime value={oldestFetchedStartTime} hour12={false} />;
  const date = <LDate value={oldestFetchedStartTime} day="2-digit" month="2-digit" />;

  const label = showDate ? (
    <FormattedMessage {...loadMoreOtherDayMessage} values={{ date, time }} />
  ) : (
    <FormattedMessage {...loadMoreTodayMessage} values={{ time }} />
  );

  return <ListViewLoadMore onLoadMore={onLoadMore} isLoadingMore={isLoadingMore} label={label} />;
}
